export function serializeObject(object: Any | null | undefined): Any {
  if (!object) {
    return {}
  }

  return JSON.parse(JSON.stringify(object))
}
